import { render, staticRenderFns } from "./PartnerLogos.vue?vue&type=template&id=7e5ed53c&scoped=true&"
import script from "./PartnerLogos.vue?vue&type=script&lang=js&"
export * from "./PartnerLogos.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogos.vue?vue&type=style&index=0&id=7e5ed53c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5ed53c",
  null
  
)

export default component.exports